// extracted by mini-css-extract-plugin
module.exports = {"serpFastBundlePreloader":"_93444fe79c--serpFastBundlePreloader--1XnY_","serpFastBundlePreloaderSpin":"_93444fe79c--serpFastBundlePreloaderSpin--1jO7a"};